const baseUrl ='https://djxmiami.com/djx/api/v1/';
export default baseUrl;
